import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_28: FaireProductEntity = {
  token: "legacy_prod_abbott-28",
  type: "product",
  name: 'Small Hanging Mouse Dark Brown 2" H',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/1c0b94cb7f473068499ae6c4de75ab3deaccb7fee5e7896102736ff3bb2ca0d1.jpeg",
  priceDollars: 12,
  subcategory: "Decorative Objects",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_home-accents"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
